import React, { useState } from "react";
import Modal from "../generic/Modal";
import InputField from "../generic/InputField";
import SharedAlertBanner from "../shared/SharedAlertBanner";

interface ForgotPasswordModalProps {
    onClose: () => void; // Function to close the modal
    onSubmit: (email: string) => Promise<any>; // Function to handle password reset request
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({ onClose, onSubmit }) => {
    const [ email, setEmail ] = useState<string>("");
    const [ successMessage, setSuccessMessage ] = useState<any>(null);
    const [ errorMessage, setErrorMessage ] = useState<any>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const data = await onSubmit(email);
        if (data.success) {
            setSuccessMessage({
                message: data.message,
            });
            setErrorMessage(null);
        } else {
            setSuccessMessage(null);
            setErrorMessage({
                message: data.message,
            });
        }
    };

    return (
        <Modal onClose={onClose}>
            <h2 className="text-lg font-semibold mb-4 text-center">Forgot Password</h2>

            <SharedAlertBanner successAlert={successMessage}
                               errorAlert={errorMessage}
                               onCloseSuccess={() => setSuccessMessage(null)}
                               onCloseError={() => setErrorMessage(null)}
            />
            <form onSubmit={handleSubmit} className="space-y-4">
                <InputField
                    type="email"
                    value={email}
                    onChange={(value) => setEmail(value as string)}
                    label="Email"
                    placeholder="Enter your email"
                    required
                    id="forgot-password-email"
                />
                <button className={"primary w-full"}>
                    Send Reset Link
                </button>
            </form>
        </Modal>
    );
};

export default ForgotPasswordModal;
